import { HeaderPage } from 'components';
import { Col } from 'antd';
import { CatalogSelector } from 'components/CatalogSelector/CatalogSelector';
import './ConfiguracionCatalogos.scss';

const ConfiguracionCatalogos = () => {
  return (
    <div className="configuracion-catalogo-main-container">
      <div className="header-page">
        <Col span={18}>
          <HeaderPage
            section2="Configuración de Catálogos"
            title=" "
            header="Selecciona el catálogo que deseas administrar."
          />
        </Col>
      </div>
      <div>
        <CatalogSelector />
      </div>
    </div>
  );
};

export default ConfiguracionCatalogos;
